<template>
  <div class="px-5 mt-9">
    <div v-if="error">{{ error }}</div>
    <div v-if="documents" class="layout">
      <ListView :todolists="documentsWithTag" />
      <TagList :todolists="documents" />
    </div>
    <div v-else>
      <Spinner />
    </div>
  </div>
</template>

<script>
import TagList from "@/components/todolist/TagList.vue"
import Spinner from "@/components/Spinner.vue"
import ListView from "@/components/todolist/ListView.vue"
import getCollection from "@/composables/getCollection"
import { useRoute } from "vue-router"
import { computed } from "vue"

export default {
  components: { ListView, Spinner, TagList },
  setup() {
    const route = useRoute()
    const { error, documents } = getCollection("todolists")

    const documentsWithTag = computed(() => {
      return documents.value.filter((p) => p.tags.includes(route.params.tag))
    })

    return { error, documents, documentsWithTag }
  },
}
</script>
